import { useMutation } from '@tanstack/react-query';
import type {
  CreatePrescriptionRequestT,
  PrescriptionT,
} from '@lotushealth/lotushealth_js_sdk/schemas';

import { fetchCreatePrescription } from '../api/createPrescription.js';

export interface CreatePrescriptionVariables {
  userId: string;
  data: CreatePrescriptionRequestT;
}

export function useCreatePrescriptionMutation() {
  return useMutation({
    mutationKey: ['rx', 'create-prescription'],
    mutationFn: async ({ userId, data }: CreatePrescriptionVariables): Promise<PrescriptionT> => {
      return await fetchCreatePrescription(userId, data);
    },
  });
}
